import { dynamicLoader } from '~/utils';

export const EstimateTemplatesPage = dynamicLoader({
  name: 'EstimateTemplatesPage',
  importFunc: () => import('./estimate-templates'),
});